<app-header></app-header>
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="large" color="#fff" type="ball-atom" [fullScreen] = "true">
    <p style="color: white" > Loading... </p>
</ngx-spinner>
<router-outlet></router-outlet>
<div style="padding-bottom: 30px;"></div>
<fit-cc-footer appVersion="{{ appVersion }}" dbVersion="{{ dbVersion }}" appEnvironment="{{ environmentTag }}">
</fit-cc-footer>
